import script from "./Guides-Data-Editor.vue?vue&type=script&setup=true&lang=js"
export * from "./Guides-Data-Editor.vue?vue&type=script&setup=true&lang=js"

import "./Guides-Data-Editor.vue?vue&type=style&index=0&id=34e9dd3f&lang=css"

const __exports__ = script;

export default __exports__